import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronUp, Filter, RotateCcw } from "feather-icons-react";
import Table from "../../../core/pagination/datatableReports";
import { useEffect } from "react";
import { OverlayTrigger } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import LoadingUtils from "../../../core/utils/LoadingUtils";
import { setheadertoggle } from "../../../redux/toggle";
import { renderTooltip } from "../../../redux/helper";
import {
  exportPDF,
  exportExcel,
  printReport,
} from "../../../core/utils/StockReportUtils";

// import {
//   printReport,
//   exportExcel,
//   exportPDF,
// } from "../../../core/utils/reportUtils";
import {
  fetchUnit,
  fetchProduct,
  fetchTax,
  fetchSettings,
  fetchCustomer,
} from "../../../redux/userSetting";
import { DatePicker, Tabs, TimePicker } from "antd";
import {
  getConsolidatedReportItemwise,
  getitemWiseSalesReport,
  getTimeBasedReport,
} from "../../../services/ReportApiService";
import {
  DatatablePagingParameter,
  Filterclass,
} from "../../../core/json/DatatablePagingParameters";
import dayjs from "dayjs";
import { useMemo } from "react";
import Branch from "../../../core/json/Branch";
import { Archive, Calendar, File, FileMinus, Layers, MapPin, User } from "feather-icons-react/build/IconComponents";
import isBetween from "dayjs/plugin/isBetween";
import { getZoneList } from "../../../services/MasterApiServices";
import Select from "react-select";

const HourlySalesReport = () => {
  const [activeTab, setActiveTab] = useState("1");
  const [searchText, setSearchText] = useState("");
  const [groupedData, setGroupedData] = useState([]);
  // keep original copies to allow searching / restoring
  const [originalGroupedData, setOriginalGroupedData] = useState([]);
  const [grandTotal, setgrandTotal] = useState([]);
  const [reportData, setreportData] = useState([]);
  const [originalReportData, setOriginalReportData] = useState([]);
  const [itemWiseData, setItemWiseData] = useState([]);
  const [APIData, setAPIData] = useState();
  const [loadingDes, setLoadingDes] = useState(false);
  const [modifiedFooterTotals, setModifiedFooterTotals] = useState({});
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [fromDate, setFromDate] = useState(dayjs());
  const [toDate, setToDate] = useState(dayjs());
  const { branch } = useSelector((state) => state.branchlist);
  // add missing lists / settings from redux (prevents no-undef ESLint errors)
    const { settingList, counterList, sectionList,productList, categoryList, groupList } =
      useSelector((state) => state.usersetting);
        const { UserList } = useSelector((state) => state.userservice);
    //const { productList }= useSelector((state) => state.usersetting);    
    
  const dispatch = useDispatch();
  const { TabPane } = Tabs;
  const format = "HH:mm";
  dayjs.extend(isBetween);
  const { togglehead } = useSelector((state) => state.headerToggle);
  const [fromTime, setFromTime] = useState(null);
  const [toTime, setToTime] = useState(null);
  const [decimalpoints, setDecimalPoints] = useState(2);
  const [productval, setproductval] = useState(null);
  const [sectionval, setsectionval] = useState(null);
  const [categoryval, setscategoryval] = useState(null);
  const [waiter, setwaiter] = useState(null);
  const [zoneName, setZone] = useState(null);
  const [zoneOptions, setZoneOptions] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  // raw itemwise mapped data (unfiltered) for client-side filtering
  const [itemWiseRawMapped, setItemWiseRawMapped] = useState([]);

  // Apply client-side filters to itemWiseRawMapped and update itemWiseData + grandTotal
  const applyItemFilters = (raw = itemWiseRawMapped) => {
    if (!Array.isArray(raw)) {
      setItemWiseData([]);
      setgrandTotal({});
      return;
    }

    const lower = (v) => (v ?? "").toString().toLowerCase();

    const filtered = raw.filter((it) => {
      // Product: prefer GUID match, fallback to product name
      if (productval) {
        const selVal = lower(productval.value);
        const selLabel = lower(productval.label);
        if (it.productGuid) {
          if (lower(it.productGuid) !== selVal) return false;
        } else {
          if (!it.itemName || (lower(it.itemName) !== selVal && lower(it.itemName) !== selLabel)) return false;
        }
      }

      // Group: prefer GUID, fallback to group name
      if (selectedGroup) {
        const selVal = lower(selectedGroup.value);
        const selLabel = lower(selectedGroup.label);
        if (it.groupGuid) {
          if (lower(it.groupGuid) !== selVal) return false;
        } else {
          if (!it.group || (lower(it.group) !== selVal && lower(it.group) !== selLabel)) return false;
        }
      }

      // Category: prefer GUID, fallback to category name
      if (categoryval) {
        const selVal = lower(categoryval.value);
        const selLabel = lower(categoryval.label);
        if (it.categoryGuid) {
          if (lower(it.categoryGuid) !== selVal) return false;
        } else {
          if (!it.category || (lower(it.category) !== selVal && lower(it.category) !== selLabel)) return false;
        }
      }

      // Section: prefer GUID, fallback to section name
      if (sectionval) {
        const selVal = lower(sectionval.value);
        const selLabel = lower(sectionval.label);
        if (it.sectionGuid) {
          if (lower(it.sectionGuid) !== selVal) return false;
        } else {
          if (!it.section || (lower(it.section) !== selVal && lower(it.section) !== selLabel)) return false;
        }
      }

      // User/Waiter: prefer GUID, fallback to user name
      if (waiter) {
        const selVal = lower(waiter.value);
        const selLabel = lower(waiter.label);
        if (it.userGuid) {
          if (lower(it.userGuid) !== selVal) return false;
        } else {
          if (!it.user || (lower(it.user) !== selVal && lower(it.user) !== selLabel)) return false;
        }
      }

      // Zone: compare by name (your zoneOptions use zone.name)
      if (zoneName?.value) {
        if (!it.zone) return false;
        if (lower(it.zone) !== lower(zoneName.value)) return false;
      }

      return true;
    });

    setItemWiseData(filtered);
    setgrandTotal({
      quantity: filtered.reduce((s, r) => s + (r.quantity || 0), 0),
      netAmount: filtered.reduce((s, r) => s + (r.total || 0), 0),
    });
  };

  // run filters immediately when any UI-filter or raw data changes (only when Item Wise tab active)
  useEffect(() => {
    if (activeTab === "3") applyItemFilters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productval, selectedGroup, categoryval, sectionval, waiter, zoneName, itemWiseRawMapped, activeTab]);

  useEffect(() => {
    handleReset();
    const match = settingList?.currencyFormat?.toString()?.match(/\.0+/);
    const currfmt = match ? match[0]?.length - 1 : 0;
    setDecimalPoints(currfmt);
  }, [branch]);

  // Function to filter and aggregate data based on the selected time range
  const filterAndAggregateData = (data, fromTime, toTime) => {
    if (!Array.isArray(data)) {
      console.error("Data is not an array:", data);
      return;
    }

    const format = "HH:mm"; // Ensure the format is consistent
    const fromTimeObj = dayjs(fromTime, format);
    const toTimeObj = dayjs(toTime, format);

    // Aggregate the filtered data
    const aggregatedData = data.reduce(
      (acc, curr) => {
        acc.netTotal += curr.netTotal || 0; // Sum net totals
        return acc;
      },
      { netTotal: 0 } // Initial accumulator with netTotal only
    );

    // Prepare the final aggregated object
    return [
      {
        billCount: data.length, // Use the length of filteredData as billCount
        netTotal: aggregatedData.netTotal, // Total net amount
        hour: `${fromTimeObj.format(format)} - ${toTimeObj.format(format)}`, // Formatted hour range
        netTotalPercent: "", // Optional: Percentage, if required
      },
    ];
  };

  // Filter API report data by time range (handles normal and overnight ranges)
  const filterReportDataByTime = (data, fromTime, toTime) => {
    if (!Array.isArray(data)) return [];
    const fmt = "HH:mm";
    const from = dayjs(fromTime, fmt);
    const to = dayjs(toTime, fmt);

    return data.filter((bill) => {
      if (!bill?.billTime) return false;
      const billTimeStr = dayjs(bill.billTime).format(fmt);
      const billTime = dayjs(billTimeStr, fmt);

      // If range crosses midnight (to < from), accept times >= from OR <= to
      if (to.isBefore(from)) {
        return billTime.isSame(from) || billTime.isSame(to) || billTime.isAfter(from) || billTime.isBefore(to);
      }

      return billTime.isSame(from) || billTime.isSame(to) || (billTime.isAfter(from) && billTime.isBefore(to));
    });
  };
  function getTimeData() {
    if (fromTime && toTime && fromDate && toDate) {
      console.log("Fetching report data for:", {
        fromDate,
        toDate,
        fromTime: fromTime?.format(format),
        toTime: toTime?.format(format),
      });
      const filteredData = filterReportDataByTime(APIData, fromTime, toTime);
      console.log("Filtered Data:", filteredData);

      // Call the filter and aggregate function and store the result
      const aggregatedResult = filterAndAggregateData(
        filteredData,
        fromTime,
        toTime
      );
      setGroupedData(aggregatedResult);
      setreportData(filteredData);
      setgrandTotal({});
    }
  }
  console.log(reportData, "report");

  // useEffect(() => {
  //   getTimeData();
  // }, [fromTime, toTime, toDate]);
  const handletogglehead = () => {
    dispatch(setheadertoggle(!togglehead));
  };
  const handleSearch = (e) => {
    setSearchText(e.target.value);
    handleFilter(e.target.value);
  };
  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };
  const handleFromDateChange = (date) => {
    setFromDate(date);

    setToDate(null);
  };
  const handleToDateChange = (date) => {
    setToDate(date);
  };
    const group = groupList?.map((e) => ({
    value: e.guid,
    label: e.name,
  }));
    const userroles = UserList?.map((e) => ({
    value: e.guid,
    label: e.name,
  }));
  const counter = counterList?.map((e) => ({
    value: e.guid,
    label: e.name,
  }));
  const section = sectionList?.map((e) => ({
    value: e.guid,
    label: e.name,
  }));
  
  const product = productList?.map((e) => ({
    value: e.guid,
    label: e.name,
  }));
  const category = categoryList?.map((e) => ({
    value: e.guid,
    label: e.name,
  }));
  // useEffect(() => {
  //   handleReportList();
  //   if (searchText) {
  //     handleFilter(searchText);
  //   }
  // }, [branch, fromDate, toDate]);

  useEffect(() => {
    if (activeTab === "1" || activeTab === "2") {
      handleReportList();
    } else if (activeTab === "3") {
      handleItemWiseReport();
    }
    if (searchText) {
      handleFilter(searchText);
    }
  }, [branch, fromDate, toDate, activeTab]);

  // helper — collect primitive values from nested object/array for searching
  const collectValues = (val) => {
    if (val === null || val === undefined) return "";
    if (typeof val === "string" || typeof val === "number" || typeof val === "boolean")
      return String(val);
    if (Array.isArray(val)) return val.map(collectValues).join(" ");
    if (typeof val === "object") return Object.values(val).map(collectValues).join(" ");
    return "";
  };

  // unified search handler for all tabs
  const handleFilter = (text) => {
    const lower = (text || "").toString().toLowerCase().trim();

    // restore originals when search cleared
    if (!lower) {
      setGroupedData(originalGroupedData);
      setreportData(originalReportData);
      // itemWiseRawMapped is already the original raw mapped array
      setItemWiseData(itemWiseRawMapped);
      return;
    }

    const matches = (item) => {
      const hay = collectValues(item).toLowerCase();
      return hay.includes(lower);
    };

    if (activeTab === "1") {
      const src = originalGroupedData.length ? originalGroupedData : groupedData;
      setGroupedData(src.filter(matches));
    } else if (activeTab === "2") {
      const src = originalReportData.length ? originalReportData : reportData;
      setreportData(src.filter(matches));
    } else if (activeTab === "3") {
      const src = itemWiseRawMapped.length ? itemWiseRawMapped : itemWiseData;
      setItemWiseData(src.filter(matches));
    }
  };

  const handleReset = () => {
    setFromDate(dayjs());
    setToDate(dayjs());
    setToTime(null);
    setFromTime(null);
    setSearchText("");
    setGroupedData([]);
    setreportData([]);
    setgrandTotal({});
    setItemWiseData([]);
    setproductval(null);
    setsectionval(null);
    setscategoryval(null);
    setwaiter(null);
    setZone(null);
    setSelectedGroup(null);
  };
  // const handleTabChange = (key) => {
  //   setActiveTab(key);
  // };
  const handleTabChange = (key) => {
    setActiveTab(key);

    if (key === "1" || key === "2") {
      handleReportList(); // Summary or Detailed
    } else if (key === "3") {
      handleItemWiseReport(); // ✅ Item Wise
    }
  };

  const getActiveTabData = () => {
    let fieldMapping = {};

    const createfieldMapping = (columns) => {
      const mappings = {};
      columns.forEach((col) => {
        mappings[col.title] = col.dataIndex;
      });
      return mappings;
    };

    switch (activeTab) {
      case "1":
        fieldMapping = createfieldMapping(columns);
        return {
          data: groupedData,
          columns: columns,
          fieldMapping,
          Rname: "Hourly Summary Reports",
        };

      case "2":
        fieldMapping = createfieldMapping(detailedColumns);
        return {
          data: reportData,
          columns: detailedColumns,
          fieldMapping,
          Rname: "Hourly Detailed Reports",
        };

      case "3":
        fieldMapping = createfieldMapping(itemwiseColumns);
        return {
          data: itemWiseData,
          columns: itemwiseColumns,
          fieldMapping,
          Rname: "Item Wise Reports",
        };

      default:
        return { data: [], columns: [] };
    }
  };

  const handleReportList = async () => {
    setLoadingDes(true);
    if (!fromDate || !toDate) {
      setLoadingDes(false);
      setGroupedData([]);
      setgrandTotal([]);
      setreportData([]);
      return;
    }
    const DatatablePagingParameters = new DatatablePagingParameter();
    // const branchobj = new Branch();
    const formattedfromDate = dayjs(fromDate)
      .startOf("day")
      .format("YYYY-MM-DD");
    const formattedtoDate = dayjs(toDate).startOf("day").format("YYYY-MM-DD");
    const Filters = new Filterclass();
    DatatablePagingParameters.PageNumber = 1;
    DatatablePagingParameters.PageSize = -1;
    Filters.Branch = branch;
    Filters.FromDate = formattedfromDate;
    Filters.ToDate = formattedtoDate;
    Filters.PaymentType = "";
    Filters.Waiter = "";
    Filters.Counter = "";
    Filters.Section = "";
    try {
      const response = await getTimeBasedReport({
        DatatablePagingParameters,
        Filters,
      });
      setLoadingDes(false);
      const data = response?.data?.salesReportTime || [];
      setreportData(data);
      setOriginalReportData(data);
      setAPIData(data);

      groupBillsByHour(data);

      setLoadingDes(false);
    } catch (error) {
      console.error(error || "Something went wrong");
      setreportData([]);
    }
  };

  const handleItemWiseReport = async () => {
    setLoadingDes(true);
    setItemWiseData([]);
    setgrandTotal({});

    try {
      const DatatablePagingParameters = new DatatablePagingParameter();
      const Filters = new Filterclass();

      DatatablePagingParameters.PageNumber = 1;
      DatatablePagingParameters.PageSize = -1;

      Filters.Branch = branch;
      Filters.FromDate = dayjs(fromDate).format("YYYY-MM-DD");
      Filters.ToDate = dayjs(toDate).format("YYYY-MM-DD");

      const response = await getitemWiseSalesReport({
        DatatablePagingParameters,
        Filters,
      });

      const rawData = response?.data?.itemWiseSalesReportDetail || [];
      const footerTotal = response?.data?.footerTotal || {};

      // 🧩 Flatten the structure for easy rendering
      const mappedData = rawData.map((item, index) => ({
        key: index + 1,
        date: dayjs(item.billDate).format("YYYY-MM-DD"),
        time: dayjs(item.billTime).format("HH:mm"),
        itemName: item.product?.name || "",
        productGuid: item.product?.guid || "",
        quantity: item.quantity ?? 0,
        category: item.product?.category?.name || "",
        categoryGuid: item.product?.category?.guid || "",
        categoryGroup: item.categoryMaster || "",
        group: item.product?.group?.name || "",
        groupGuid: item.product?.group?.guid || "",
        section: item.section?.name || "", // assuming "Section" = Lounge
        sectionGuid: item.section?.guid || "",
        zone: item.zoneName || "",
        user: item.user?.name || "",
        userGuid: item.user?.guid || "",
        total: item.total ?? 0,
      }));

      // keep raw mapped data and apply client-side filters (instant)
      setItemWiseRawMapped(mappedData);
      applyItemFilters(mappedData);

      setgrandTotal({
        quantity: footerTotal.Quantity || 0,
        rate: footerTotal.Rate || 0,
        vatAmount: footerTotal.VATAmount || 0,
        taxAmount: footerTotal.TaxAmount || 0,
        cgst: footerTotal.CGST || 0,
        sgst: footerTotal.SGST || 0,
        netAmount: footerTotal.NetAmount || 0,
      });
    } catch (error) {
      console.error("Error fetching Item Wise Report:", error);
      setItemWiseData([]);
    } finally {
      setLoadingDes(false);
    }
  };

  function groupBillsByHour(data) {
    if (fromTime && toTime && fromDate && toDate) {
      getTimeData();
    } else {
      const result = {};

      data.forEach((bill) => {
        const hour = new Date(bill.billTime).getHours(); // Extract hour
        const hourRange = `${String(hour).padStart(2, "0")}:00 - ${String(
          hour
        ).padStart(2, "0")}:59`; // 24-hour format

        const date = bill.transactionDate; // Extract transactionDate

        if (!result[date]) {
          result[date] = {}; // Initialize an object for each date
        }

        if (!result[date][hourRange]) {
          result[date][hourRange] = {
            hour: hourRange,
            billCount: 0,
            netTotal: 0,
          };
        }

        result[date][hourRange].billCount += 1;
        result[date][hourRange].netTotal += bill.netTotal;
      });

      // Convert to an array and sort by transactionDate and hour
      const groupedArray = Object.keys(result)
        .sort() // Sort dates in ascending order
        .flatMap((date) =>
          Object.values(result[date]).sort(
            (a, b) =>
              parseInt(a.hour.split(":")[0]) - parseInt(b.hour.split(":")[0])
          )
        );

      // Calculate grand total
      const grandTotal = groupedArray.reduce(
        (acc, curr) => acc + curr.netTotal,
        0
      );

      // Calculate grand bill count
      const grandBillCount = groupedArray.reduce(
        (acc, curr) => acc + curr.billCount,
        0
      );

      const footerTotals = {
        billCount: grandBillCount,
        netTotal: grandTotal,
      };

      // Add netTotal percentage
      groupedArray.forEach((item) => {
        item.netTotalPercent = ((item.netTotal / grandTotal) * 100).toFixed(
          decimalpoints
        ); // Format to 2 decimals
      });
      setGroupedData(groupedArray);
      setOriginalGroupedData(groupedArray);
      setgrandTotal(footerTotals);
      // return { groupedArray, footerTotals };
    }
  }
  const shouldShowNetTotalPercent = groupedData.some(
    (row) => row.netTotalPercent
  );
     useEffect(() => {
      const fetchZones = async () => {
        try {
          const response = await getZoneList();
          // Map to { value, label }
          const formattedZones = (response || []).map(zone => ({
            value: zone.name,
            label: zone.name,
          }));
          setZoneOptions(formattedZones);
        } catch (error) {
          console.error("Failed to fetch zones:", error);
        }
      };

      fetchZones();
    }, []);

  const columns = [
    {
      title: "Time Range",
      dataIndex: "hour",
      key: "hour",
      sorter: (a, b) => {
        const [startA] = a.hour.split(" - ");
        const [startB] = b.hour.split(" - ");
        return parseInt(startA.split(":")[0]) - parseInt(startB.split(":")[0]);
      },
      render: (text) => <strong>{text}</strong>,
    },
    {
      title: "Bill Count",
      dataIndex: "billCount",
      key: "billCount",
      sorter: (a, b) => a.billCount - b.billCount,
    },
    {
      title: "Sales Amount",
      dataIndex: "netTotal",
      key: "netTotal",
      sorter: (a, b) => a.netTotal - b.netTotal,
      render: (value) => value.toFixed(decimalpoints),
    },

    ...(shouldShowNetTotalPercent
      ? [
          {
            title: "Sales %",
            dataIndex: "netTotalPercent",
            key: "netTotalPercent",
            sorter: (a, b) =>
              parseFloat(a.netTotalPercent) - parseFloat(b.netTotalPercent),
            render: (value) => `${value}%`,
          },
        ]
      : []),
  ];

  const detailedColumns = [
    {
      title: "Bill No.",
      dataIndex: "billNo",
      key: "billNo",
      sorter: (a, b) => a.billNo - b.billNo,
    },
    {
      title: "Date and Time",
      dataIndex: "billTime",
      key: "billTime",
      sorter: (a, b) => new Date(a.billTime) - new Date(b.billTime),
      render: (text) => {
        const date = new Date(text);
        const formattedDate = date.toLocaleString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        });
        return <strong>{formattedDate}</strong>;
      },
    },
    {
      title: "User",
      dataIndex: "userName",
      key: "userName",
      sorter: (a, b) => a.userName.localeCompare(b.userName),
    },
    {
      title: "Counter",
      dataIndex: "counterName",
      key: "counterName",
      sorter: (a, b) => a.counterName.localeCompare(b.counterName),
    },
    {
      title: "Section",
      dataIndex: "sectionName",
      key: "sectionName",
      sorter: (a, b) => a.sectionName.localeCompare(b.sectionName),
    },
    {
      title: "Amount",
      dataIndex: "netTotal",
      key: "netTotal",
      sorter: (a, b) => a.netTotal - b.netTotal,
    },
  ];



  const itemwiseColumns = [
  {
    title: "Date",
    dataIndex: "date",
    key: "date",
    sorter: (a, b) => new Date(a.date) - new Date(b.date),
    render: (text) => dayjs(text).format("DD-MM-YYYY"),
  },
  {
    title: "Time",
    dataIndex: "time", // match mappedData field
    key: "time",
    sorter: (a, b) => dayjs(a.time, "HH:mm").diff(dayjs(b.time, "HH:mm")),
    render: (text) => text,
  },
    { title: "Item Name", dataIndex: "itemName", key: "itemName" },
    { title: "Qty", dataIndex: "quantity", key: "quantity", align: "right" },
    { title: "Category", dataIndex: "category", key: "category" },
    {
      title: "Category Group",
      dataIndex: "categoryGroup",
      key: "categoryGroup",
    },
    { title: "Group", dataIndex: "group", key: "group" },
    // { title: "Lounge", dataIndex: "lounge", key: "lounge" },
    { title: "Zone", dataIndex: "zone", key: "zone" },
    {title: "Section", dataIndex: "section", key: "section"},
    { title: "User", dataIndex: "user", key: "user" },
  ];

  function handleLoadReport() {
    if (activeTab === "1" || activeTab === "2") {
      handleReportList();
    } else if (activeTab === "3") {
      handleItemWiseReport();
    }
    if (searchText) {
      handleFilter(searchText);
    }
  }

  return (
    <div>
      <LoadingUtils loading={loadingDes} />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Hourly Reports</h4>
              </div>
            </div>
            <ul className="table-top-head">
              <li>
                <OverlayTrigger placement="top" overlay={renderTooltip("PDF")}>
                  <Link
                    onClick={() =>
                      exportPDF(getActiveTabData, grandTotal, "Hourly Reports")
                    }
                  >
                    <ImageWithBasePath
                      src="assets/img/icons/pdf.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Excel")}
                >
                  <Link
                    onClick={() =>
                      exportExcel(
                        getActiveTabData,
                        grandTotal,
                        "Hourly Reports"
                      )
                    }
                  >
                    <ImageWithBasePath
                      src="assets/img/icons/excel.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Print")}
                >
                  <Link
                    onClick={() =>
                      printReport(
                        getActiveTabData,
                        grandTotal,
                        "Hourly Reports"
                      )
                    }
                  >
                    <i data-feather="printer" className="feather-printer" />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Refresh")}
                >
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    // onClick={() => handleReportList()}
                    onClick={() => {
                      if (activeTab === "1" || activeTab === "2") {
                        handleReportList();
                      } else if (activeTab === "3") {
                        handleItemWiseReport();
                      }
                    }}
                  >
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Collapse")}
                >
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    id="collapse-header"
                    className={togglehead ? "active" : ""}
                    onClick={handletogglehead}
                  >
                    <ChevronUp />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
          </div>

          <div className="card table-list-card">
            <div className="card-body my-2 mx-2">
              {/* <div className="table-top"> */}
              <div className="row gx-2 gy-2 align-items-center">
                <div className="d-flex flex-wrap align-items-center w-100">
                  {/* Search Input */}
                  <div className="me-3">
                    <input
                      type="text"
                      placeholder="Search"
                      className="form-control form-control-sm formsearch"
                      aria-controls="DataTables_Table_0"
                      value={searchText}
                      onChange={handleSearch}
                      aria-label="Search"
                    />
                  </div>

                  {/* Date Range: From Date */}
                  <div className="me-3">
                    <div className="input-blocks">
                      <label htmlFor="from-date" className="me-2">
                        From Date
                      </label>
                      <div className="input-groupicon calender-input">
                        <Calendar className="info-img" />
                        <DatePicker
                          className="datetimepicker"
                          id="from-date"
                          placeholderText="From Date"
                         // selected={fromDate}
                          value={fromDate}
                          onChange={handleFromDateChange}
                          startDate={fromDate}
                          selectsStart
                         // dateFormat="dd/MM/yyyy"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Date Range: To Date */}
                  <div className="me-3">
                    <div className="input-blocks">
                      <label htmlFor="to-date" className="me-2">
                        To Date
                      </label>
                      <div className="input-groupicon calender-input">
                        <Calendar className="info-img" />
                        <DatePicker
                          id="to-date"
                          placeholderText="To Date"
                        //  selected={toDate}
                          value={toDate}
                          onChange={handleToDateChange}
                          minDate={fromDate}
                          startDate={fromDate}
                          selectsEnd
                          disabled={!fromDate}
                        //  dateFormat="dd/MM/yyyy"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Buttons */}
                  <div className="ms-auto d-flex">
                    <button
                      className="btn btn-submit rounded-2 me-2"
                      onClick={handleLoadReport}
                      disabled={!fromDate || !toDate}
                    >
                      <i data-feather="search" className="feather-search" />{" "}
                      Search
                    </button>
                    <button
                      className="btn btn-reset rounded-2"
                      onClick={handleReset}
                      disabled={!fromDate && !toDate && !searchText}
                    >
                      <i
                        data-feather="refresh-cw"
                        className="feather-refresh-cw"
                      />{" "}
                      Reset
                    </button>
                  </div>
                            <div className="search-path">
                  <Link
                    className={`btn btn-filter ${
                      isFilterVisible ? "setclose" : ""
                    }`}
                    id="filter_search"
                    onClick={toggleFilterVisibility}
                  >
                    <Filter className="filter-icon" />
                    <span onClick={toggleFilterVisibility}>
                      <ImageWithBasePath
                        src="assets/img/icons/closes.svg"
                        alt="img"
                      />
                    </span>
                  </Link>
                </div>
              </div>

              <div
                className={`card${isFilterVisible ? " visible" : ""}`}
                id="filter_inputs"
                style={{ display: isFilterVisible ? "block" : "none" }}
              >
                <div className="card-body pb-0">
                  <div className="row">
                        {/* Time Pickers */}
                  <div className="col-lg-4 col-sm-6 col-12 d-flex align-items-center mb-3">
                    <TimePicker
                      className="form-control form-control-sm me-2"
                      value={fromTime}
                      onChange={setFromTime}
                      placeholder="From Time"
                      format={format}
                    />
                    <TimePicker
                      className="form-control form-control-sm"
                      value={toTime}
                      onChange={setToTime}
                      placeholder="To Time"
                      format={format}
                      disabled={!fromTime}
                    />
                  </div>

                    <div className="col-lg-2 col-sm-6 col-12">
                      <div className="input-blocks">
                        <Layers className="info-img" />
                        <Select
                          className="img-select"
                          options={product}
                          value={productval}
                          onChange={setproductval}
                          isClearable
                          classNamePrefix="react-select"
                          placeholder="Enter Product"
                        />
                      </div>
                    </div>
                    <div className="col-lg-2 col-sm-6 col-12">
                       <div className="input-blocks">
                         <FileMinus className="info-img" />
                         <Select
                         className="img-select"
                         options={group}
                         value={selectedGroup}
                         onChange={(e) => setSelectedGroup(e)}
                         isClearable
                         classNamePrefix="react-select"
                         placeholder="Group"
                       />
                   </div>
                     </div>
                    <div className="col-lg-2 col-sm-6 col-12">
                      <div className="input-blocks">
                        <File className="info-img" />
                        <Select
                          className="img-select"
                          options={section}
                          value={sectionval}
                          onChange={setsectionval}
                          isClearable
                          classNamePrefix="react-select"
                          placeholder="Enter Section"
                        />
                      </div>
                    </div>
          
                    <div className="col-lg-2 col-sm-6 col-12">
                      <div className="input-blocks">
                        <Archive className="info-img" />
                        <Select
                          className="img-select"
                          options={category}
                          value={categoryval}
                          onChange={setscategoryval}
                          isClearable
                          classNamePrefix="react-select"
                          placeholder="Enter Category"
                        />
                      </div>
                    </div>
                    <div className="col-lg-2 col-sm-6 col-12">
                      <div className="input-blocks">
                        <User className="info-img" />
                        <Select
                          className="img-select"
                          options={userroles}
                          value={waiter}
                          onChange={setwaiter}
                          isClearable
                          classNamePrefix="react-select"
                          placeholder="Enter User"
                        />
                      </div>
                    </div>
                       <div className="col-lg-2 col-sm-6 col-12">
                      <div className="input-blocks">
                        <MapPin className="info-img" />
                        <Select
                          className="img-select"
                          options={zoneOptions}
                          value={zoneName}
                          onChange={setZone}
                          isClearable
                          classNamePrefix="react-select"
                          placeholder="Enter Zone"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                </div>
              </div>

              <div className="table-responsive mt-3">
                <Tabs defaultActiveKey="1" onChange={handleTabChange}>
                  <TabPane tab="Summary View" key="1">
                    <Table
                      columns={columns}
                      dataSource={groupedData}
                      footerTotals={grandTotal}
                    />
                  </TabPane>
                  <TabPane tab="Detailed View" key="2">
                    <Table
                      columns={detailedColumns}
                      dataSource={reportData}
                      footerTotals={grandTotal}
                    />
                  </TabPane>
                  <TabPane tab="Item Wise" key="3">
                    <Table
                      columns={itemwiseColumns}
                      dataSource={itemWiseData}
                      footerTotals={grandTotal}
                    />
                  </TabPane>
                </Tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default HourlySalesReport;
